<template>
  <circle cx="8" cy="8" r="8" fill="#FF9F04" />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8 3C7.44772 3 7 3.44772 7 4V8C7 8.55228 7.44772 9 8 9C8.55228 9 9 8.55228 9 8V4C9 3.44772 8.55228 3 8 3ZM8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11Z"
    fill="white"
  />
</template>
